const STATUS_PRIORITY = Object.freeze({
    red: 3,
    yellow: 2,
    gray: 1,
    green: 0,
});

export const normalizeAxis = (axis) => {
    if (axis == null) return '';
    const raw = Array.isArray(axis) ? axis[0] : axis;
    const value = String(raw).trim().toLowerCase();
    if (!value) return '';
    if (value === '13' || value === '1-3' || value === 'x') return '13';
    if (value === '24' || value === '2-4' || value === 'y') return '24';
    return value;
};

export const getAxisLabel = (axis) => {
    const normalized = normalizeAxis(axis);
    return normalized ? `軸${normalized}` : '';
};

export const pickWorstStatus = (statuses = []) => {
    let best = null;
    let bestScore = -1;
    for (const status of statuses) {
        if (!status) continue;
        const score = STATUS_PRIORITY[status] ?? -1;
        if (score > bestScore) {
            best = status;
            bestScore = score;
        }
    }
    return best;
};

export const buildWorstStatusMap = (
    alerts,
    { getKey, onlyActive = false } = {}
) => {
    const map = new Map();
    if (!Array.isArray(alerts)) return map;

    for (const alert of alerts) {
        if (!alert) continue;
        if (onlyActive && alert.is_active === false) continue;
        const key = typeof getKey === 'function' ? getKey(alert) : alert?.[getKey];
        if (!key) continue;
        const nextStatus = pickWorstStatus([map.get(key), alert.status]);
        if (nextStatus) {
            map.set(key, nextStatus);
        }
    }

    return map;
};

export const expandAxisAlerts = (alerts = []) => {
    if (!Array.isArray(alerts)) return [];
    return alerts.flatMap((alert) => {
        if (!alert) return [];
        const axisValue = alert.axis ?? alert.Axis ?? alert.axis_name;
        if (Array.isArray(axisValue)) {
            return axisValue.map((axis) => ({ ...alert, axis }));
        }
        if (typeof axisValue === 'string' && axisValue.includes(',')) {
            return axisValue
                .split(',')
                .map((axis) => axis.trim())
                .filter(Boolean)
                .map((axis) => ({ ...alert, axis }));
        }
        return [alert];
    });
};
